// effects/personal-details.effects.ts
import { inject } from '@angular/core'
import { createEffect } from '@ngrx/effects'
import { Actions, ofType } from '@ngrx/effects'
import { BankService } from '../../services/bank.service'
import { ToastrService } from 'ngx-toastr'
import { catchError, exhaustMap, map, mergeMap, of, switchMap } from 'rxjs'
import {
  createBank,
  createBankFailure,
  createBankSuccess,
  deleteBank,
  deleteBankFailure,
  deleteBankSuccess,
  loadBanks,
  loadBanksFailure,
  loadBanksSuccess,
  updateBank,
  updateBankFailure,
  updateBankSuccess
} from './bank.actions'
import { Store } from '@ngrx/store'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'

export const loadBanks$ = createEffect(
  (actions$ = inject(Actions), bankService = inject(BankService)) =>
    actions$.pipe(
      ofType(loadBanks),
      switchMap(
        (
          action // Use action.filter here
        ) =>
          bankService.getBanks(action.params, action.page, action.limit).pipe(
            map(res =>
              loadBanksSuccess({
                banks: res.bankdetails
              })
            ),
            catchError(error => of(loadBanksFailure({ error: error.message })))
          )
      )
    ),
  { functional: true }
)

export const createBank$ = createEffect(
  (
    actions$ = inject(Actions),
    bankService = inject(BankService),
    toastr = inject(ToastrService),
    store = inject(Store),
    modalService = inject(NgbModal)
  ) =>
    actions$.pipe(
      ofType(createBank),
      exhaustMap(({ payload }) => {
        // 🔥 RETURN the inner observable here
        return bankService.createBank(payload).pipe(
          map(created => {
            toastr.success('Bank created successfully!', 'Success')
            // store.dispatch(loadBanks({ params: null, page: 1, limit: 10 }))
            modalService.dismissAll()
            return createBankSuccess({ bank: created })
          }),
          catchError(error => {
            toastr.error('There was an error creating the Bank.', 'Error')
            return of(createBankFailure({ error }))
          })
        )
      })
    ),
  { functional: true, dispatch: true }
)

export const updateBank$ = createEffect(
  (
    actions$ = inject(Actions),
    bankService = inject(BankService),
    toastr = inject(ToastrService),
    store = inject(Store),
    modalService = inject(NgbModal)
  ) =>
    actions$.pipe(
      ofType(updateBank), // 🔁 Listen for updateBank action
      exhaustMap(({ id, payload }) => {
        return bankService.updateBank(id, payload).pipe(
          map(updated => {
            toastr.success('Bank updated successfully!', 'Success')
            // store.dispatch(loadBanks({ params: null, page: 1, limit: 10 }))
            modalService.dismissAll()
            return updateBankSuccess({ bank: updated })
          }),
          catchError(error => {
            toastr.error('There was an error updating the Bank.', 'Error')
            return of(updateBankFailure({ error }))
          })
        )
      })
    ),
  { functional: true, dispatch: true }
)

export const deleteBank$ = createEffect(
  (actions$ = inject(Actions), bankService = inject(BankService), toastr = inject(ToastrService)) =>
    actions$.pipe(
      ofType(deleteBank),
      exhaustMap(action =>
        bankService.deleteBank(action.id).pipe(
          map(() => {
            toastr.success('Bank deleted successfully!')
            return deleteBankSuccess({ id: action.id })
          }),
          catchError(error => {
            toastr.error('Failed to delete Bank: ' + error.error.message)
            return of(deleteBankFailure({ error }))
          })
        )
      )
    ),
  { functional: true }
)

export const bankEffects = {
  createBank$,
  loadBanks$,
  updateBank$,
  deleteBank$
}
